module.exports = __webpack_public_path__ + "static/media/right.e171f92b.svg";